/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { Table, Space } from "antd";
import { serialNum } from "../../../utils";
import { useNavigate } from "react-router";
import back_img from "../../../assests/images/rightVector.svg";
import urls from "../../../api/urls";
import API from "../../../api";

import "./style.scss";
const UpdateTripList = () => {
  const navigate = useNavigate();
  const [tripList, setTripList] = useState();
  const [loading, setLoading] = useState(false);
  const { UPDATE_TRIP_LIST } = urls;
  const getTripList = async () => {
    setLoading(true);
    let response = await API.Api(UPDATE_TRIP_LIST).getWithUserNPremiseHeader();
    if (response?.status) {
      setTripList(response?.response?.data);
      setLoading(false);
    }
  };
  useEffect(() => {
    getTripList();
  }, []);

  const columns = [
    {
      title: "Sl No",
      align: "center",
      with: 10,
      render: (a, b, idx) => serialNum(20, 1, idx),
    },
    {
      title: "Trip ID",
      dataIndex: "tripId",
      key: "tripId",
      render: (text) => <span>{text || "------"}</span>,
    },
    {
      title: "Vehicle LCR Id",
      dataIndex: "vehicleLcrId",
      key: "vehicleLcrId",
      render: (text) => <span>{text || "------"}</span>,
    },
    {
      title: "Vehicle LCR Status",
      dataIndex: "vehicleLcrStatus",
      key: "vehicleLcrStatus",
      render: (text) => <span>{text || "------"}</span>,
    },
    {
      title: "Mode",
      dataIndex: "travelBy",
      key: "travelBy",
      render: (text) => <span>{text || "------"}</span>,
    },
    {
      title: "Vehicle Number",
      dataIndex: "vehicleNum",
      key: "vehicleNum",
      render: (text) => <span>{text || "------"}</span>,
    },
    {
      title: "Flight Number",
      dataIndex: "flightNum",
      key: "flightNum",
      render: (text) => <span>{text || "------"}</span>,
    },
    {
      title: "Created Date",
      dataIndex: "createDate",
      key: "createDate",
      render: (text) => <span>{text.replace(" ", "/") || "------"}</span>,
    },

    {
      title: "Trip Status",
      dataIndex: "status",
      key: "status",
      render: (text) => <span>{text || "------"}</span>,
    },
    {
      title: "Action",
      key: "action",
      render: (data, record) => (
        <Space size="middle">
          <a onClick={() => navigate("/update-trip", { state: record })}>
            Update trip
          </a>
        </Space>
      ),
    },
  ];
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };
  return (
    <div className=" bagging-shipment p-2">
      <div className="align-center mt-1 mb-1">
        <img
          src={back_img}
          onClick={() => navigate("/create-or-update-trip")}
          style={{ cursor: "pointer" }}
        />
        <p
          style={{
            margin: "0",
            paddingLeft: "5px",
            fontWeight: "700",
            fontSize: "18px",
            lineHeight: "32px",
            letterSpacing: "-0.25px",
            color: "#061624",
          }}
        >
          <b>Update Trip List</b>
        </p>
      </div>
      <div className="lcr-table-container">
        <Table 
        loading={loading} 
        columns={columns} 
        dataSource={tripList} 
        pagination={{
          itemRender: itemRender,
        }}
        />
      </div>
    </div>
  );
};

export default UpdateTripList;
